import React, { useState } from "react";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";

const TransferFundsPage = () => {
  const [data, setData] = useState({
    wallet_address: "",
    amount: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  return (
    <div className="mono_transferfund_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_transferfund_form_card"
      >
        <div className="mono_section_title">
          <h2>Fund Transfer</h2>
        </div>
        <div className="mono_transferfund_page_content">
          <form onSubmit={handleSubmit}>
            <div className="form_group">
              <Input
                label="Receiver Wallet Address"
                type="text"
                name="wallet_address"
                placeholder="Enter receiver wallet address"
                onChange={(e) => setData({ ...data, wallet_address: e.target.value })}
                className="input_field"
              />
            </div>
            <div className="form_group">
              <Input
                label="Amount (TRX)"
                type="text"
                name="amount"
                placeholder="Enter send amount"
                onChange={(e) => setData({ ...data, amount: e.target.value })}
                className="input_field"
              />
            </div>
            <Button type="submit" className="submit_btn">
              fund transfer
            </Button>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default TransferFundsPage;
